import { render, staticRenderFns } from "./SocialNetwork.vue?vue&type=template&id=5de11b56"
import script from "./SocialNetwork.vue?vue&type=script&lang=js"
export * from "./SocialNetwork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports